
import { IGlobalState } from "@/store";
import { useStore } from "vuex";
import { computed, defineComponent, reactive, ref, toRefs, watch } from "vue";
import {
  setCurrentAreaItem,
  useSchoolList,
  useAreaList,
  usePlatFormList,
} from "@/hooks/school";
import AREA_TYPE, { IAreaItem } from "@/typings/area";
import AUTH_TYPE, {
  IAuthObjItem,
  IPlatFormItem,
  ISchoolItem,
} from "@/typings/school";
import { applyAppSchool } from "@/service/api";
import { ElMessage } from "element-plus";

export default defineComponent({
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: String,
      default: "",
    },
    appId: {
      type: String,
      default: "",
    },
  },
  setup(props, context) {
    const state = reactive({
      type: 1,
      clickModalClose: false,
      selectAllStatu: false,
      authTypeList: [
        {
          id: 1,
          name: "学校",
        },
        {
          id: 2,
          name: "区平台",
        },
      ],
    });
    const store = useStore<IGlobalState>();
    const tableRef = ref<any>(null);
    const schools = computed(() => store.state.school.schools);
    const platForms = computed(() => store.state.school.platForms);
    const selSchoolList = ref<IAuthObjItem[]>([]);
    const currSelectionList = ref<ISchoolItem[]>([]);
    const currSelectionPlatFormList = ref<IPlatFormItem[]>([]);

    const provinces = computed(() => store.state.school.provinces);
    const citys = computed(() => store.state.school.citys);
    const districts = computed(() => store.state.school.districts);

    // 省
    const provinceId = computed({
      get: () => store.state.school.provinceId,
      set: (val) => {
        store.state.school.provinceId = val;
      },
    });

    // 市
    const cityId = computed({
      get: () => store.state.school.cityId,
      set: (val) => {
        store.state.school.cityId = val;
      },
    });

    // 区
    const districtId = computed({
      get: () => store.state.school.districtId,
      set: (val) => {
        store.state.school.districtId = val;
      },
    });

    // 获取关键字
    const keyWord = computed({
      get: () => store.state.school.keyWord,
      set: (val) => {
        store.state.school.keyWord = val;
      },
    });

    // 区
    const authType = computed({
      get: () => store.state.school.authType,
      set: (val) => {
        store.state.school.authType = val;
      },
    });

    // 获取当前页码数
    const page = computed({
      get: () => store.state.school.schools.page,
      set: (val) => {
        store.state.school.schools.page = val;
      },
    });
    // 获取区平台当前页码数
    const platFormPage = computed({
      get: () => store.state.school.platForms.page,
      set: (val) => {
        store.state.school.platForms.page = val;
      },
    });

    /**
     * 获取区域列表
     */
    const getAreaData = async () => {
      await useAreaList(
        store,
        state.type,
        state.type === AREA_TYPE.PROVINCE_TYPE
          ? ""
          : state.type === AREA_TYPE.CITY_TYPE
          ? provinceId.value
          : cityId.value
      );
    };

    /**
     * 获取学校列表
     */
    const getSchools = async () => {
      await useSchoolList(
        store,
        props.appId,
        provinceId.value,
        cityId.value,
        districtId.value,
        keyWord.value,
        page.value,
        schools.value.limit
      );
    };

    /**
     * 获取区平台列表
     */
    const getPlatForms = async () => {
      await usePlatFormList(
        store,
        props.appId,
        provinceId.value,
        cityId.value,
        districtId.value,
        keyWord.value,
        platFormPage.value,
        platForms.value.limit
      );
    };

    /**
     * 搜索
     */
    async function handleSearch() {
      if (authType.value == AUTH_TYPE.SCHOOL) {
        page.value = 1;
        await getSchools();
      } else {
        platFormPage.value = 1;
        await getPlatForms();
      }
    }
    /**
     * 关闭弹窗
     */
    function handleClose() {
      context.emit("close-modal");
      selSchoolList.value = [];
      currSelectionList.value = [];
      currSelectionPlatFormList.value = [];
      provinceId.value = "";
      cityId.value = "";
      districtId.value = "";
      keyWord.value = "";
      authType.value = AUTH_TYPE.SCHOOL;
    }
    /**
     * 获取已选学校id
     */
    // function getSchoolIds() {
    //   let ids = "";
    //   ids = selSchoolList.value
    //     .map(function (elem) {
    //       return elem.id;
    //     })
    //     .join(",");

    //   return ids;
    // }
    /**
     * 获取已选学校集合
     */
    // function getSelectedSchool() {
    //   const schoolList: any[] = [];
    //   selSchoolList.value.forEach((item) => {
    //     schoolList.push({
    //       schoolId: item.id,
    //       schoolName: item.school_name,
    //     });
    //   });
    //   return schoolList;
    // }
    /**
     *
     */
    function changeAuthType() {
      state.selectAllStatu = false;
      handleSearch();
    }
    /**
     * 点击授权
     */
    async function authSchool() {
      // const ids: string = getSchoolIds();
      // const schoolList: any[] = getSelectedSchool();
      if (selSchoolList.value.length === 0) {
        ElMessage({ message: "请选择学校", type: "error" });
        return;
      }
      const params = {
        appId: props.appId,
        // ids: ids,
        userId: props.userId,
        schoolJson: JSON.stringify(selSchoolList.value),
      };
      const result = await applyAppSchool(params);
      if (result.code == 1) {
        ElMessage({ message: "授权成功", type: "success" });
        handleClose();
        context.emit("update-table");
      } else {
        ElMessage({ message: result.msg, type: "error" });
      }
    }
    /**
     * 根据省市区 id获取省市区对应名称
     */
    function findAreaNameById(id: string, type: AREA_TYPE) {
      let sourceArr: IAreaItem[] = [];
      if (type === AREA_TYPE.PROVINCE_TYPE) {
        sourceArr = provinces.value;
      } else if (type === AREA_TYPE.CITY_TYPE) {
        sourceArr = citys.value;
      } else {
        sourceArr = districts.value;
      }
      const curAreaItem: IAreaItem[] = sourceArr.filter(
        (item) => item.id === id
      );

      return curAreaItem[0];
    }
    /**
     * 改变省市区
     */
    async function onProvinceChange(id: string, type: AREA_TYPE) {
      const curAreaItem = findAreaNameById(id, type);
      await setCurrentAreaItem(store, type, curAreaItem);
      if (type === AREA_TYPE.PROVINCE_TYPE) {
        state.type = AREA_TYPE.CITY_TYPE;
      } else if (type === AREA_TYPE.CITY_TYPE) {
        state.type = AREA_TYPE.DISTRICT_TYPE;
      }
      await getAreaData();
      handleSearch();
    }
    /**
     * 点击添加或移除
     */
    function tableRowClick(row: any) {
      // 当该行已经被选中过
      selSchoolList.value.forEach(function (item: any, index: number) {
        if (row.id === item.schoolId) {
          selSchoolList.value.splice(index, 1);
        }
      });
      tableRef.value.toggleRowSelection(row);
    }
    /**
     * 表格选项发生变化
     */
    function selectionChange(vals: any[]) {
      const _selectionList = JSON.parse(JSON.stringify(selSchoolList.value));
      if (authType.value == AUTH_TYPE.SCHOOL) {
        currSelectionList.value = JSON.parse(JSON.stringify(vals));
      } else {
        currSelectionPlatFormList.value = JSON.parse(JSON.stringify(vals));
      }

      if (vals.length) {
        if (!selSchoolList.value.length) {
          vals.forEach(function (item, index) {
            selSchoolList.value.push({
              schoolId: vals[index].id,
              schoolName:
                authType.value == AUTH_TYPE.SCHOOL
                  ? vals[index].school_name
                  : vals[index].platformName,
              type: authType.value,
            });
          });
        } else {
          vals.forEach(function (item, index) {
            for (let i = 0; i < selSchoolList.value.length; i++) {
              if (item.id === selSchoolList.value[i].schoolId) {
                break;
              } else if (i + 1 === selSchoolList.value.length) {
                _selectionList.push({
                  schoolId: vals[index].id,
                  schoolName:
                    authType.value == AUTH_TYPE.SCHOOL
                      ? vals[index].school_name
                      : vals[index].platformName,
                  type: authType.value,
                });
              }
            }
          });
          selSchoolList.value = JSON.parse(JSON.stringify(_selectionList));
        }
      }
      if (authType.value == AUTH_TYPE.SCHOOL) {
        state.selectAllStatu = vals.length === schools.value.rows.length;
      } else {
        state.selectAllStatu = vals.length === platForms.value.rows.length;
      }
    }
    /**
     * 根据授权类型获取当前目标集合
     */
    function getTargetArr(type: string) {
      let targetArr: any = [];

      if (authType.value == AUTH_TYPE.SCHOOL) {
        targetArr = type == "add" ? currSelectionList.value : schools.value;
      } else {
        targetArr =
          type == "add" ? currSelectionPlatFormList.value : platForms.value;
      }

      return targetArr;
    }
    /**
     * 删除选择的临时标签
     */
    function removeItem(index: number) {
      const _tagId: string = selSchoolList.value[index].schoolId;
      let _tagIndex: any = "null";

      const targetArr = getTargetArr("remove");

      for (let i = 0; i < targetArr.rows.length; i++) {
        if (_tagId === targetArr.rows[i].id) {
          _tagIndex = i;
          break;
        }
      }
      selSchoolList.value.splice(index, 1);
      if (_tagIndex !== "null") {
        tableRef.value.toggleRowSelection(targetArr.rows[_tagIndex]);
      }
      if (selSchoolList.value.length === 0) {
        state.selectAllStatu = false;
      }
    }
    /**
     * 全选
     */
    function handleSelectAll(statu: boolean) {
      if (!statu) {
        let _differ = 0; // 差异值
        const _selectionList = JSON.parse(JSON.stringify(selSchoolList.value));
        const targetArr = getTargetArr("add");
        // 当取消全选时剔除选中项
        selSchoolList.value.forEach(function (item, index) {
          for (let i = 0; i < targetArr.length; i++) {
            if (targetArr[i].id === item.schoolId) {
              _selectionList.splice(index - _differ, 1);
              _differ++;
              break;
            }
          }
        });
        selSchoolList.value = JSON.parse(JSON.stringify(_selectionList));
      }
      tableRef.value.toggleAllSelection();
    }
    watch(
      () => props.dialogVisible,
      async (newVal) => {
        if (newVal) {
          await getAreaData();
          await getSchools();
        }
      }
    );
    return {
      ...toRefs(state),
      tableRef,
      schools,
      selSchoolList,
      keyWord,
      page,
      platFormPage,
      provinces,
      citys,
      districts,
      provinceId,
      cityId,
      districtId,
      authType,
      onProvinceChange,
      getSchools,
      handleSearch,
      tableRowClick,
      selectionChange,
      removeItem,
      authSchool,
      handleClose,
      handleSelectAll,
      platForms,
      changeAuthType,
        getPlatForms
    };
  },
});
